// extracted by mini-css-extract-plugin
export default {"image":"report-modal-module--image--f9ebe","text":"report-modal-module--text--b1948","title":"report-modal-module--title--d4f1c","actions":"report-modal-module--actions--fd2a8"};